import './App.css';

import { Admin, CustomRoutes, Resource } from 'react-admin';
import { Route } from 'react-router-dom';
import dataProvider from './Providers/dataProvider';
import authProvider from './Providers/authProvider';

import { Dashboard, Help } from './Pages';
import { AppLayout, appTheme, appDarkTheme } from './Layout';
import {
	Session,
	Interview,
	User,
	Group,
	Module,
	PromptTemplate,
	PromptPreview,
	IPAccess
} from './Resources';

function App() {
	
	return (
		<Admin
			dashboard={Dashboard}
			dataProvider={dataProvider}
			authProvider={authProvider}
			layout={AppLayout}
			theme={appTheme}
			darkTheme={appDarkTheme}
			defaultTheme='dark'
			disableTelemetry
			requireAuth
			>
			<Resource name="sessions"  {...Session} />
			<Resource name="modules" {...Module} />
			<Resource name="prompt-versions" options={{ label: 'Prompt Versions' }} />
			<Resource name="prompt-templates" {...PromptTemplate} options={{ label: 'Prompt Templates' }} />
			<Resource name="prompt-preview" {...PromptPreview} options={{ label: 'Prompt Preview' }} />
			<Resource name="interviews" {...Interview} options={{label: "Conversations"}} />
			<Resource name="groups" {...Group} />
			<Resource name="users" {...User} />
			<Resource name="ip-access" {...IPAccess} options={{ label: 'IP Access' }} />

			<CustomRoutes>
				<Route path="/help" element={<Help />} />
			</CustomRoutes>
		</Admin>
	);
}

export default App;
